import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { Toaster } from 'sonner';
import '@/App.css';
import { CounsellingProvider } from '@/components/CounsellingModal';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import FloatingButtons from '@/components/FloatingButtons';
import {
  HomePage, ItalyPage, MBBSPage, UniversitiesPage,
  SuccessPage, ScholarshipsPage, AboutPage, ScrollToTop,
} from '@/pages/SimplePages';
import ContactPage from '@/pages/ContactPage';
import AdminPage from '@/pages/AdminPage';
import PrivacyPolicyPage from '@/pages/PrivacyPolicyPage';

// Careers module (Phase 1) — isolated, lazy-loaded so it never affects
// initial bundle size or runtime of the marketing site.
const CareersApp = lazy(() => import('@/careers/CareersApp'));

// Layout wrapper for public pages
const PublicLayout = ({ children }) => (
  <>
    <Navbar />
    <main>{children}</main>
    <Footer />
    <FloatingButtons />
  </>
);

function App() {
  return (
    <div className="App" data-testid="euroelite-app">
      <BrowserRouter>
        <CounsellingProvider>
          <Toaster position="top-center" theme="dark" richColors />
          <ScrollToTop />
          <Routes>
            {/* Careers module (Phase 1) — completely isolated at /careers/* */}
            <Route
              path="/careers/*"
              element={
                <Suspense fallback={<div style={{ minHeight: '100vh', background: '#050d1f' }} />}>
                  <CareersApp />
                </Suspense>
              }
            />

            {/* Admin (no navbar/footer) */}
            <Route path="/admin" element={<AdminPage />} />

            {/* Public pages */}
            <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
            <Route path="/italy" element={<PublicLayout><ItalyPage /></PublicLayout>} />
            <Route path="/mbbs" element={<PublicLayout><MBBSPage /></PublicLayout>} />
            <Route path="/universities" element={<PublicLayout><UniversitiesPage /></PublicLayout>} />
            <Route path="/success" element={<PublicLayout><SuccessPage /></PublicLayout>} />
            <Route path="/scholarships" element={<PublicLayout><ScholarshipsPage /></PublicLayout>} />
            <Route path="/about" element={<PublicLayout><AboutPage /></PublicLayout>} />
            <Route path="/contact" element={<PublicLayout><ContactPage /></PublicLayout>} />
            <Route path="/privacy-policy" element={<PublicLayout><PrivacyPolicyPage /></PublicLayout>} />
            <Route path="*" element={<PublicLayout><HomePage /></PublicLayout>} />
          </Routes>
        </CounsellingProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
